import { useState, forwardRef, Ref } from 'react';
import Input, { FullInputProps } from './Input';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

const PASSWORD = 'password';
const TEXT = 'text';

export type PasswordInputProps = Omit<FullInputProps, 'type' | 'leadingIcon'>;

export default forwardRef(function Password(
    { ...rest }: PasswordInputProps,
    ref: Ref<HTMLInputElement>,
) {
    const [reveal, setReveal] = useState(PASSWORD);
    const toggle = () => {
        if (reveal === PASSWORD) {
            setReveal(TEXT);
            return;
        }
        setReveal(PASSWORD);
    };
    return (
        <Input
            {...rest}
            ref={ref}
            type={reveal}
            trailingIcon={
                reveal === PASSWORD ? (
                    <EyeSlashIcon
                        data-testid="eye-slash-icon"
                        onClick={toggle}
                        className="alli-h-5 alli-w-5 alli-cursor-pointer alli-text-gray-700"
                        aria-hidden="true"
                    />
                ) : (
                    <EyeIcon
                        data-testid="eye-icon"
                        onClick={toggle}
                        className="alli-h-5 alli-w-5 alli-cursor-pointer alli-text-gray-700"
                        aria-hidden="true"
                    />
                )
            }
        />
    );
});
